import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import TopBar from './global-components/topbar';
import OngoingInfo from './section-components/ongoing-info';
import FeaturesV1 from './section-components/features-v1';

const Completed = () => {
    return <div>
        <TopBar/>
        <Navbar />
        <PageHeader headertitle="Ongoing Properties" subheader="Ongoing" />
        {/* <OngoingInfo /> */}
        <FeaturesV1/>
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Completed
